import React from 'react';
import './Footer.scss';
import images from '../../constants/images';
import { BsWhatsapp, BsFacebook, BsGithub } from 'react-icons/bs';
import {FaCopyright} from 'react-icons/fa'

const Footer = () => {
  return (
    <div className='app__footer section__padding-footer' id='contact'>
      <div className='app__footer-top'>
        <div className='app__footer-top_quote'>
          <p className='p__opensans'>When You Teach A Wolf</p>
          <p className='p__opensans'>To Meditate, He Become </p>
          <p className='p__opensans'>Aware Wolf!</p>
        </div>


        <div className='app__footer-top_logo'>
          <img src={images.logo} alt="logo" />
        </div>

        <div className='app__footer-top_icon'>
          <a href="https://api.whatsapp.com/send?phone=60173875223&text=Hi%20Masbro," target='_blank' className='p__poppins ws'><BsWhatsapp/></a>
          <a href="https://www.facebook.com/zarul.supalameyo" target='_blank' className='p__poppins fb'><BsFacebook/></a>
        </div>
      </div>

      <div className='app__footer-copyright'>
        <h1 className='p__poppins'><FaCopyright/> MasBro | Since 2022</h1>
      </div>
    </div>
  )
}

export default Footer